function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 *  拦截 hash / history
 *
 *
 * */

// 存放所有事件
var handlers = {};
// 记录 url
var lastHref;
var triggerHandlers = function triggerHandlers(type, data) {
  if (!type || !handlers[type]) return;
  var _iterator = _createForOfIteratorHelper(handlers[type]),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var handler = _step.value;
      handler(data);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var hackHistory = function hackHistory() {
  var _window, _window$history;
  if (!((_window = window) !== null && _window !== void 0 && (_window$history = _window.history) !== null && _window$history !== void 0 && _window$history.pushState)) {
    return;
  }
  // 浏览器 navigator 触发 // 用户输入 url、点击前进、后退
  var oldOnPopState = window.onpopstate;
  window.onpopstate = function () {
    var to = window.location.href;
    var from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from: from,
      to: to
    });
    if (oldOnPopState) {
      try {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return oldOnPopState.apply(this, args);
      } catch (e) {}
    }
  };

  // history pushState 或 replaceState 触发， history api 方式触发
  var wrapHistoryFn = function wrapHistoryFn(type) {
    var originalHistoryFunction = window.history[type];
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      // console.log('HistoryFunction', this, args)
      var url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        var from = lastHref;
        var to = String(url);
        lastHref = to;
        triggerHandlers('history', {
          from: from,
          to: to
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  };
  window.history.pushState = wrapHistoryFn('pushState');
  window.history.replaceState = wrapHistoryFn('replaceState');
};
var hackEventHandler = function hackEventHandler(type) {
  if (type === 'history') {
    hackHistory();
  }
};
export var registerTriggerHandlers = function registerTriggerHandlers(type, callback) {
  var _handlers$type;
  handlers[type] = handlers[type] || [];
  (_handlers$type = handlers[type]) === null || _handlers$type === void 0 ? void 0 : _handlers$type.push(callback);
  hackEventHandler(type);
};